import { useRef } from 'react';
import styled from 'styled-components';
import { SkillsByName } from '../../../services/skill';
import { TaskRewardProps } from '../../../services/task';
import Popover, { DropperRefProps } from '../../../ui/Popover/Popover';
import Input, { InputSize, InputType } from '../../../ui/Input/Input';
import Menu from '../../../ui/Menu/Menu';
import MenuOption from '../../../ui/Menu/MenuOption';
import Icon from '../../../ui/Icon';
import { stores, useStore } from '../../../utils/store';

interface Props {
    reward: TaskRewardProps;
    onChange: (task: TaskRewardProps) => void;
    onRemove: () => void;
}

export default function TaskEditReward({ reward, onChange, onRemove }: Props) {
    const iconRef = useRef<HTMLElement>(null);
    const dropperRef = useRef<DropperRefProps>(null);
    const [skills,] = useStore(stores.skills);

    function onXpChange(xp: TaskRewardProps['xp']) {
        const rewardCopy = Object.assign({}, reward);
        rewardCopy.xp = Number(xp);
        onChange(rewardCopy);
    }

    function onTypeChange(type: TaskRewardProps['type']) {
        const rewardCopy = Object.assign({}, reward);
        rewardCopy.type = type;
        onChange(rewardCopy);
        if (dropperRef.current) dropperRef.current.close()
    }

    return (
        <Wrapper>
            <Icon ref={iconRef} onClick={() => { if (dropperRef.current) dropperRef.current.open() }} className='tesk-edit-reward-icon' size={24} icon={SkillsByName[reward.type].icon}></Icon>
            <Popover targetRef={iconRef} ref={dropperRef}>
                <Menu onChange={onTypeChange}>
                    {skills.map(skill =>
                        <MenuOption key={skill.id} style={{ display: 'flex', justifyContent: 'space-between', }} value={skill.id}><Icon icon={skill.icon} size={24}></Icon> <div style={{ paddingLeft: 20 }}>{skill.name}</div></MenuOption>
                    )}
                </Menu>
                <div onClick={() => { onRemove(); if (dropperRef.current) dropperRef.current.close() }}>
                    <MenuOption value={3}><div style={{ padding: 20 }}>Remove</div></MenuOption>
                </div>
            </Popover>
            <Input value={reward.xp.toString() as any} onChange={onXpChange} className='tesk-edit-reward-input' type={InputType.NUMBER} rightOrnament='XP' size={InputSize.SMALL} name={SkillsByName[reward.type].name}></Input>
        </Wrapper >
    )
}

const Wrapper = styled.div`
        background-color: ${props => props.theme.backgroundColor};
        border-radius: ${props => props.theme.borderRadius};

        width: 124px;
        height: 100px;
        padding: 10px;

        display: flex;
        flex-direction: column;

        .tesk-edit-reward-icon {
            flex-grow: 1;
            cursor: pointer;
            /* margin-top: 10px; */
            margin: -10px -10px 0 -10px;
        }

        .tesk-edit-reward-input input {
            /* text-align: center; */
            /* padding: 8px 44px 8px 44px; */
        }
`